<template>
  <div class="pointDown">
    <div class="bodyDown"></div>
    <div class="rightDown">
      <div class="topDown"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pointDown"
}
</script>

<style scoped lang="less">
.pointDown{
  width: 20px;
  height: 50px;
  //display: flex;
  //align-items: center;
}

.bodyDown{
  width: 12px;
  margin: auto;
  height: 40px;
  background: #354CFB;
}

.rightDown{
  width: 10px;
  position: relative;
}

.topDown{
  border: 10px solid transparent;
  border-top: 10px solid #354CFB;
  width: 0;
  height: 0px;
}
</style>